import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ComponentBaseComponent } from '@app/core/components/component-base/component-base.component';
import { PrintService } from '@app/core/services/print.service';
import { PdfService } from '@app/services/pdf.service';
import { ReportService } from '@app/services/report.service';

@Component({
    selector: 'tt-report-preview',
    templateUrl: './report-preview.component.html',
    styleUrls: ['./report-preview.component.css'],
})
export class ReportPreviewComponent extends ComponentBaseComponent implements OnInit {
    /**
     * The keyno of the report to preview, required if html-report.
     */
    @Input()
    public reportDefKeyno: `${number}` | number = 0;

    /**
     * The keyno of the report type, required to know which preview to load.
     */
    @Input()
    public reportTypeKeyno: `${number}` | number = 0;

    /**
     * Parameters to use for the generated report.
     */
    @Input()
    public parameters: { [key: string]: string } = {};

    public previewLink: SafeResourceUrl = '';

    public generating = false;

    constructor(private print: PrintService, private pdf: PdfService, private report: ReportService, private sanitizer: DomSanitizer) {
        super();
    }

    private async getReport() {
        if (+this.reportTypeKeyno === 1) {
            const reportDefGet = await this.report.getP2ReportDef({ p2_reportdef_keyno: +this.reportDefKeyno });

            return this.print.printService.preview({ reportKeyno: +reportDefGet.printserver_keyno, parameters: this.parameters });
        } else if (+this.reportTypeKeyno === 2) {
            return this.pdf.preview({ reportKeyno: +this.reportDefKeyno, parameters: this.parameters });
        } else {
            throw Error('Report type not supported in preview');
        }
    }

    async ngOnInit() {
        try {
            this.generating = true;

            this.previewLink = this.sanitizer.bypassSecurityTrustResourceUrl(await this.getReport());
        } catch (error) {
            console.error(error);
        } finally {
            this.generating = false;
        }
    }
}
